import { createSlice } from "@reduxjs/toolkit";


// initialize userToken from local storage
const accessToken = localStorage.getItem('accessToken')
    ? localStorage.getItem('accessToken')
    : null

const userData = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: userData,
        accessToken: accessToken,
    },
    reducers: {
        setAuth: (state, action) => {
            const { accessToken, user } = action.payload;

            state.accessToken = accessToken;
    
            state.user = user;

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('user', JSON.stringify(user));
        },
        setToken: (state, action) => {
            const { accessToken } = action.payload;
            state.accessToken = accessToken;
            localStorage.setItem('accessToken', accessToken);
        },
        updateUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
            localStorage.setItem('user', JSON.stringify(state.user));
        },
        setProfileImage: (state, action) => {
            state.user = { ...state.user, profileImage: action.payload };
            localStorage.setItem('user', JSON.stringify(state.user));
        },
        logout: (state) => {
            state.accessToken = null;
            state.user = null;

            localStorage.clear();
        }
    }
});

export const {
    setAuth,
    setToken,
    updateUser,
    setProfileImage,
    logout
} = authSlice.actions

export default authSlice.reducer;